module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sidebar-wrapper"
  }, [_vm._m(0), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('ul', _vm._l((_vm.sidebarLinks), function(link, index) {
    return _c('router-link', {
      ref: link.name,
      refInFor: true,
      attrs: {
        "to": link.path,
        "tag": "li"
      }
    }, [_c('a', [_c('i', {
      class: link.icon
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(link.name))])])])
  }), 1)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('div', {
    staticClass: "simple-text",
    attrs: {
      "href": "#"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-529e20e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/SidebarPlugin/SideBar.vue
// module id = 784
// module chunks = 0